import React, { Component } from "react";
import { Button, Modal } from "antd";
import { apiCustomer } from "../../../../api/api-customer";
import { alert } from "../../../../common/utils/alert";

export class BottomButton extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  onChangeType = (type) => this.setState({ type });

  cancelEditUser = (isEditBack) => {
    let title = "Huỷ thao tác";
    let content =
      "Bạn có chắc chắn muốn quay lại? Nếu bạn quay lại mọi thông tin trước đó sẽ không được lưu.";
    const { cancelEdit } = this.props;
    Modal.confirm({
      title: title,
      icon: null,
      content: content,
      okText: "Có",
      okType: "danger",
      cancelText: "Không",
      onOk: () => {
        if (isEditBack) {
          cancelEdit();
        }
      },
      onCancel() {},
      className: "del-comfirm",
    });
  };

  goBack = (isEditBack) => {
    let title = "Huỷ thao tác";
    let content =
      "Bạn có chắc chắn muốn quay lại? Nếu bạn quay lại mọi thông tin trước đó sẽ không được lưu.";
    const { cancelEdit, close } = this.props;
    Modal.confirm({
      title: title,
      icon: null,
      content: content,
      okText: "Có",
      okType: "danger",
      cancelText: "Không",
      onOk: () => {
        if (isEditBack) {
          cancelEdit();
        }
        close();
      },
      onCancel() {},
      className: "del-comfirm",
    });
  };

  render() {
    const {
      submit,
      typeOption,
      close,
      enableEdit,
      deleteUser,
      inactiveDelete,
    } = this.props;
    return (
      <div className="user-account-container">
        {typeOption === "create_new" ? (
          <>
            <Button onClick={() => this.goBack()} className="cancel-btn">
              Huỷ
            </Button>
            <Button className="add-btn" onClick={submit}>
              Thêm tài khoản
            </Button>
          </>
        ) : typeOption === "show_detail" ? (
          <>
            <Button onClick={enableEdit} className="add-btn">
              Chỉnh sửa
            </Button>
            <Button onClick={close} className="cancel-btn">
              Hủy
            </Button>
          </>
        ) : (
          <>
            <Button
              onClick={() => this.cancelEditUser(true)}
              className="cancel-btn"
            >
              Huỷ
            </Button>
            <Button className="add-btn" onClick={submit}>
              Lưu thay đổi
            </Button>
          </>
        )}
      </div>
    );
  }
}
